// extracted by css-extract-rspack-plugin
export default {"Box":"action-buttons-module__Box__kbogp"};